<template>
    <div class="bg-image-wrapper" :style="{backgroundColor: bgColor}">
        <img :src="src" style="display:none;">
        <parallax v-if="parallax" :speedFactor="parallax.speedFactor" :direction="parallax.direction"
            :fixed="parallax.fixed" :sectionHeight="parallax.sectionHeight" :breakpoint="parallax.breakpoint"
            :sectionClass="parallax.sectionClass" :containerClass="parallax.containerClass"
            :parallaxClass="parallax.parallaxClass" :fixedClass="parallax.fixedClass">
            <div class="bg-image" :class="{
                'image-loaded': loaded,
                'blur-effect': blur,
                'opacity-effect': effect==='opacity'
            }" :style="{backgroundImage: 'url(' + imageSrc + ')'}"></div>
        </parallax>
        <template v-else>
                <div class="bg-image" @click="onClickedChild(src)" :class="{
                    'image-loaded': loaded,
                    'blur-effect': blur,
                    'opacity-effect': effect==='opacity'
                }" :style="{backgroundImage: 'url(' + imageSrc + ')'}"></div>
            
        </template>
        <slot></slot>
    </div>
</template>

<script>
    import Parallax from 'vue-parallaxy'

    export default {
        components: {
            Parallax
        },
        props: {
            src: {
                type: String,
                required: true,
                default: null
            },
            placeholder: {
                type: String,
                required: false
            },
            bgColor: {
                type: String,
                required: false,
                default: null
            },
            effect: {
                type: String,
                required: false,
                default: null
            },
            parallax: {
                type: Object,
                required: false,
                default: null
            },
            debug: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                loaded: false
            }
        },
        computed: {
            blur() {
                return (this.placeholder) ? true : false;
            },
            imageSrc: {
                get: function () {
                    if (!this.loaded && this.placeholder) {
                        return (this.placeholder);
                    } else {
                        return this.src;
                    }
                },
                set: function (newValue) {}
            }
        },
        methods: {
            onClickedChild (imageSrc) {
                this.$root.$emit('click-parent', imageSrc);
            }
        },
        beforeCreate() {
            // console.log('beforeCreate');
        },
        created() {
            // console.log('created');
        },
        beforeMount() {
            // console.log('beforeMount');
        },
        mounted() {
            this.$el.children[0].addEventListener("load", e => {
                if (!this.debug) {
                    this.loaded = true;
                }
                this.$emit('image-loaded')
            });
        },
        beforeUpdate() {
            // console.log('beforeUpdate');
        },
        updated() {
            // console.log('updated');
        },
        beforeDestroy() {
            // console.log('beforeDestroy');
        },
        destroyed() {
            // console.log('destroyed');
        },
    }
</script>

<style lang="scss">
    .bg-image-wrapper {
        position: relative;
        overflow: hidden;

        &.bg-contain {
            .bg-image {
                background-size: contain;
            }
        }

        &.bg-left {
            .bg-image {
                background-position: 0% 0%;
            }
        }

        &.bg-right {
            .bg-image {
                background-position: 100% 0%;
            }
        }

        &.bg-right-40 {
            .bg-image {
                background-position: 60% 0%;
            }
        }

        &.bg-top {
            .bg-image {
                background-position: 50% 0%;
            }
        }

        &.bg-bottom {
            .bg-image {
                background-position: 50% 100%;
            }
        }

        .Masthead {
            position: absolute;
            width: 100%;
        }
    }

    .bg-image {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0%;
        left: 0%;
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
        backface-visibility: hidden;

        &.opacity-effect {
            opacity: 0;
            transition: opacity 250ms ease-out;

            &.image-loaded {
                opacity: 1;
            }
        }

        &.blur-effect {
            width: 100%;
            height: 100%;
            top: 0%;
            left: 0%;
            filter: blur(30px);
            transition: filter 1000ms ease-out;

            &.image-loaded {
                filter: blur(0);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/js/components/bg-image/bg-image.vue